import React from 'react'

import UnsaveButton from '@cinch/oxd-containers/unsave-button/src'

import * as styles from './unavailable.module.css'

const Unavailable: React.FC<{ vehicleId: number }> = ({ children, vehicleId }) => (
  <div className={styles.wrapper}>
    <div>{children}</div>
    <div className={styles.button}>
      <UnsaveButton vehicleId={vehicleId} />
    </div>
  </div>
)

export default Unavailable
